<template>
  <section class="h-full w-full">
    <div class="text-xl font-bold">
      {{ mypageRouterList.name }}
    </div>

    <!-- mypage 하위 메뉴 -->
    <div class="mt-6 flex flex-col">
      <div
        v-for="(item, index) in mypageRouterList.children"
        :key="index"
        class="mb-[10px] text-lg"
      >
        <!-- 유닛 하위메뉴 -->
        <SubMenuUnit v-if="item.path === 'unit'" />

        <router-link :to="`/mypage/${item.path}`" v-else>
          {{ item.name }}
        </router-link>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import useRenderRouter from "@/lib/useRenderRouter";
import SubMenuUnit from "./submenu/unit.vue";

const { mypageRouterList } = useRenderRouter();
</script>

<style lang="scss" scoped>
.router-link-exact-active {
  text-decoration: underline;
  text-underline-position: under;
}
</style>
